// 根据产品编号和数量获取总价
// url : /marco/api/v1/product/getPriceByQuantity?mcode=SBO340&quantity=100000000

interface queryModel {
  productCode: string;
  number: string | number;
}

// 根据产品编号和数量获取阶梯价格
export const getPriceByProductCode = (query: queryModel) => {
  const URL = `/marco/api/v1/product/getPriceByQuantity?mcode=${query.productCode}&quantity=${query.number}`;
  return getApi(URL);
};

// 获取购物车数据
// url: /jeecg-boot/order/api/v1/shoppingcart/list
export const getShoppingCartList = () => {
  const URL = "/order/api/v1/shoppingcart/list?type=1";
  return getApi(URL);
};

// 加入购物车
// url: /jeecg-boot/order/api/v1/shoppingcart/add
export const addShoppingcart = (options: any) => {
  const URL = "/order/api/v1/shoppingcart/add";
  return postApi(URL, options);
};

// 删除购物车
// url: /jeecg-boot/order/api/v1/shoppingcart/clear
export const delShoppingCart = (options: any) => {
  const URL = "/order/api/v1/shoppingcart/deleteBatch";
  return deleteApi(URL, options);
};

// 根据 Marco# 批量获取 goodsSkuId
// url: /marco/api/v1/product/ids
export const getGoodsSkuIds = (options: any) => {
  const URL = "/marco/api/v1/product/ids";
  return postApi(URL, options);
};
